








































import { Component, Mixins, Prop } from 'vue-property-decorator';
import CreateDisplayMessage from '@/shared/CreateDisplayMessage';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { Activity } from '@/@types/activity';

@Component({
  components: {
    AccountIcon,
  },
})
export default class ActivityListCard extends Mixins(CreateDisplayMessage) {
  private listItemPixelHeight: number = 123;
  @Prop({ required: true })
  private activities!: Activity[];

  @Prop({ required: true, default: true })
  private isActivityLoading!: boolean

  private get isActivityLoadingNow() {
    return this.isActivityLoading;
  }
}
